<template lang="pug">
  md-list.centros-municipales-list(v-if="centrosMunicipales")
    template(v-for="({ properties }) in centrosMunicipalesWithRefugiosList")
      md-list-item.centro-municipal(
        ref="centroMunicipalItems"
        :key="`centro-municipal-${properties.id}`"
        :id="`centro-municipal-${properties.id}`"
        :class="properties.id === centroMunicipalId ? 'selected' : ''"
        @click="setCentroMunicipalAndUpdateRoute({ centroMunicipal: properties, })")
        span.md-list-item-text {{properties.centros_municipales}}
          .centro-municipal-info
            .direccion {{properties.direccion}}
            .telefono {{properties.contacto}}
            .refugios(v-if="(properties.refugiosCensados && properties.refugiosCensados.length) || (properties.refugiosNoCensados && properties.refugiosNoCensados.length)")
              .asu-title Albergues
              template(v-if="properties.refugiosCensados && properties.refugiosCensados.length")
                .asu-title Censados
                router-link.refugiosCensados(
                  v-for="({ nro, nombre }) in properties.refugiosCensados"
                  :key="`refugio-${nro}`"
                  :to="{ name: 'map', query: { ver: 'refugios', refugio_nro: nro } }"
                  @click.native="$event.stopImmediatePropagation()")
                    | - {{nombre}}
              template(v-if="properties.refugiosNoCensados && properties.refugiosNoCensados.length")
                .asu-title No censados
                div.refugiosNoCensados(:key="" v-for="({ nro, nombre }) in properties.refugiosNoCensados") - {{nombre}}
        DownloadButton.md-list-action(:href="centroMunicipalURL" type="link")
      md-divider
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getData } from '@/utils/object'
import { getArray } from '@/utils/array'
import { centroMunicipalURL, refugioDefaultYear } from '@/constants.js'
import { scrollElementIfExistInList } from '@/utils/dom.js'

export default {
  computed: {
    ...mapGetters([ 'centrosMunicipales', 'centroMunicipal', 'refugiosByCentroMunicipalId', 'thereIsCensoForRefugioNro', 'refugiosYear' ]),
    centroMunicipalId () {
      return getData(this.centroMunicipal).id
    },
    centrosMunicipalesWithRefugiosList () {
      getArray(getData(this.centrosMunicipales).features).forEach(centroMunicipal => {
        centroMunicipal.properties.refugiosCensados = []
        centroMunicipal.properties.refugiosNoCensados = []
        this.refugiosByCentroMunicipalId(centroMunicipal.properties.id).forEach(refugio => {
          if (this.thereIsCensoForRefugioNro(refugio.nro)) {
            centroMunicipal.properties.refugiosCensados.push(refugio)
          } else if (this.refugiosYear === refugioDefaultYear && refugio.estado === 'Activo') {
            centroMunicipal.properties.refugiosNoCensados.push(refugio)
          }
        })
      })
      this.scrollToCentrosMunicipales()
      return getData(this.centrosMunicipales).features
    },
    tabContentParentElement () {
      return this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.$parent && this.$parent.$parent.$parent.$parent.$parent && this.$parent.$parent.$parent.$parent.$parent.$parent && this.$parent.$parent.$parent.$parent.$parent.$parent.$el
    }
  },
  props: {
    toScroll: Object,
    scroll: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.scrollToCentrosMunicipales()
  },
  data: () => ({ centroMunicipalURL }),
  methods: {
    ...mapActions(['setCentroMunicipalAndUpdateRoute']),
    scrollToCentrosMunicipales () {
      if (!this.scroll) return
      if (!this.centroMunicipal) return
      if (!this.tabContentParentElement) return
      const id = this.centroMunicipal.id
      const self = this
      setTimeout(() => {
        scrollElementIfExistInList(self.$refs.centroMunicipalItems, id, self.tabContentParentElement)
      })
    }
  },
  watch: {
    centroMunicipal () {
      this.scrollToCentrosMunicipales()
    },
    toScroll () {
      this.scrollToCentrosMunicipales()
    },
    scroll () {
      this.scrollToCentrosMunicipales()
    },
    refugiosYear () {
      this.scrollToCentrosMunicipales()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.centros-municipales-list
  .md-list-item
    padding: $f7px 0 $f8px 0
    span.md-list-item-text
      font-weight: bold
      .centro-municipal-info
        margin-left: $f10px
        font-weight: normal
    .md-list-action
      margin-right: $f10px
    &.centro-municipal.selected
      background-color: rgba(0, 0, 0, .12)
    .refugios
      .asu-title
        font-weight: bold
      a
        display: block
  .refugiosCensados,
  .refugiosNoCensados
    font-size: $f16px

</style>
